






















































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class ConfirmClearAll extends Vue {
  @Prop({ default: "Confirm" }) title!: string;

  protected closeModal(): void {
    this.$emit("close");
  }
}
